export interface Broadside {
  id: number
  title: string
  text: string
  year?: number
  categories: Category[]
  locations: Location[]
  image: string
}

export type Category = 'songs and poems' | 'murder' | 'trials' | 'courtship'
export const catsList: Category[] = [
  'songs and poems',
  'murder',
  'trials',
  'courtship',
]

export type Reaction = 'enjoyable' | 'funny' | 'sad'
export type LatLon = { lat: number; lng: number }
export type LocationMap = Record<Location, LatLon>

export type Location =
  | 'Calton'
  | 'Cowgate'
  | 'Edinburgh'
  | 'Fife'
  | 'Newington'
  | 'Old Town'
  | 'Cullen'
  | 'Glasgow'
  | 'Cupar'
  | 'Dundee'
  | 'Irvine'
  | 'Leith'
  | 'Wick'
  | 'Forth'
  | 'Balfron'
  | 'Highland'
  | 'Stirling'
  | 'Dumfries'
  | 'Roslin'
  | 'Portobello'
  | 'Barrhead'
  | 'Bothwell'
  | 'Douglas'
  | 'Greenock'
  | 'Kilmarnock'
  | 'Linlithgow'
  | 'Paisley'
  | 'Renfrew'
  | 'Houston'
  | 'Leslie'
  | 'Alloa'
  | 'Port Glasgow'
  | 'Musselburgh'
  | 'Law'
  | 'Aberdeen'
  | 'Forfar'
  | 'Haddington'
  | 'West Calder'
  | 'Rutherglen'
  | 'Dunfermline'
  | 'Logan'
  | 'Queensferry'
  | 'Ayr'
  | 'Grangemouth'
  | 'Hamilton'
  | 'Johnstone'
  | 'Kirkintilloch'
  | 'Lanark'
  | 'Livingston'
  | 'New Town'
  | 'Muirhead'
  | 'Elgin'
  | 'Inverness'
  | 'Moffat'
  | 'Perth'
  | 'Redding'
  | 'Stanley'
  | 'Rothes'
  | 'Anstruther'
  | 'Dalry'
  | 'Dalrymple'
  | 'Erskine'
  | 'Fenwick'
  | 'Keith'
  | 'Renton'
  | 'Selkirk'
  | 'Duns'
  | 'Laurieston'
  | 'Sanquhar'
  | 'Blackburn'
  | 'Coatbridge'
  | 'Stonehouse'
  | 'Bannockburn'
  | 'Falkirk'
  | 'Grassmarket'
  | 'Dalkeith'
  | 'Gullane'
  | 'Liberton'
  | 'Airdrie'
  | 'Dumbarton'
  | 'East Kilbride'
  | 'Earlston'
  | 'Jedburgh'
  | 'Kelso'
  | 'Kirkwall'
  | 'Lawnmarket'
  | 'Arbroath'
  | 'Strathblane'
  | 'Neilston'
  | 'Burntisland'
  | 'Ochiltree'
  | 'Elderslie'
  | 'Armadale'
  | 'Denny'
  | 'Bonhill'
  | 'Lauder'
  | 'Callander'
  | 'Crieff'
  | 'Kirkliston'
  | 'Winchburgh'
  | 'Stockbridge'
  | 'Loanhead'
  | 'Methven'
  | 'Inchinnan'
  | 'Kilbarchan'
  | 'Beith'
  | 'Girvan'
  | 'Forres'
  | 'Cleland'
  | 'Lesmahagow'
  | 'Larbert'
  | 'Granton'
  | 'Fallin'
  | 'Kinghorn'
  | 'North Berwick'
  | 'Ardrossan'
  | 'Prestonpans'
  | 'Cambuslang'
  | 'Dunbar'
  | 'Montrose'
  | 'Innerleithen'
  | 'Kelty'
  | 'Dunlop'
  | 'Stonehaven'
  | 'Dollar'
  | 'Tarbolton'
  | 'Thurso'
  | 'Holyrood'
  | 'Greenhill'
  | 'Huntly'
  | 'Nairn'
  | 'Peterhead'
  | 'Stranraer'
  | 'Torrance'
  | 'Saltcoats'
  | 'Dundonald'
  | 'Annan'
  | 'Eaglesham'
  | 'Bathgate'
  | 'Airth'
  | 'Largs'
  | 'Gourock'
  | 'Kincardine'
  | 'Blantyre'
  | 'Shotts'
  | 'Blairgowrie'
  | 'Ormiston'
  | 'Peebles'
  | 'Invergordon'
  | 'Tain'
  | 'Balloch'
  | 'Banff'
  | 'Fort William'
  | 'Aberfeldy'
  | 'Galashiels'
  | 'Tranent'
  | 'Craiglockhart'
  | 'Insch'
  | 'Hawick'
  | 'Gretna'
  | 'Calton Hill'
  | 'Dingwall'
  | 'Lochwinnoch'
  | 'Auchinleck'
  | 'Cardross'
  | 'Carron'
  | 'Kilsyth'
  | 'Inverleith'
  | 'Buckie'
  | 'Rothesay'
  | 'Kippen'
  | 'Dornoch'
  | 'Errol'
  | 'St Andrews'
  | 'Chryston'
  | 'Tarbert'
  | 'Slamannan'
  | 'Killearn'
  | 'Cumbernauld'
  | 'Culloden'
  | 'Clarkston'
  | 'Dunblane'
  | 'Thornton'
  | 'Rhu'
  | 'Ellon'
  | 'Pittenweem'
  | 'Kirriemuir'
  | 'Carnwath'
  | 'Banchory'
  | 'Helensburgh'
  | 'Plains'
  | 'Auchterarder'
  | 'Saline'
  | 'Biggar'
  | 'Tullibody'
  | 'Milngavie'
  | 'Broxburn'
  | 'Bridge of Allan'
  | 'Doune'
  | 'Kinglassie'
  | 'Cowie'
  | 'Alva'
  | 'Aberlady'
  | 'Mauchline'
  | 'Galston'
  | 'Stromness'
  | 'Troon'
  | 'Kemnay'
  | 'Inverurie'
  | 'Maybole'
  | 'Kintore'
  | 'Letham'
  | 'Stewarton'
  | 'Kinross'
  | 'Inverkeithing'
  | 'Prestwick'
  | 'Brechin'
  | 'Harthill'
  | 'Carluke'
  | 'Golspie'
  | 'Kilbirnie'
  | 'Crail'
  | 'Falkland'
  | 'Alexandria'
  | 'Linwood'
